/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* TelemetryContext.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { objFreeze } from "@microsoft/applicationinsights-core-js";
export var AppExtensionKeys = objFreeze({
  id: "id",
  ver: "ver",
  appName: "name",
  locale: "locale",
  expId: "expId",
  env: "env"
});
export var WebExtensionKeys = objFreeze({
  domain: "domain",
  browser: "browser",
  browserVer: "browserVer",
  screenRes: "screenRes",
  userConsent: "userConsent",
  consentDetails: "consentDetails"
});
export var UserExtensionKeys = objFreeze({
  locale: "locale",
  localId: "localId",
  id: "id"
});
export var OSExtKeys = objFreeze({
  osName: "name",
  ver: "ver"
});
export var SDKExtKeys = objFreeze({
  ver: "ver",
  seq: "seq",
  installId: "installId",
  epoch: "epoch"
});
export var IntWebExtKeys = objFreeze({
  msfpc: "msfpc",
  anid: "anid",
  serviceName: "serviceName"
});
export var UtcExtKeys = objFreeze({
  popSample: "popSample",
  eventFlags: "eventFlags"
});
export var LocExtKeys = objFreeze({
  tz: "tz"
});
export var SessionExtKeys = objFreeze({
  sessionId: "sesId"
});
export var DeviceExtKeys = objFreeze({
  localId: "localId",
  deviceClass: "deviceClass",
  make: "make",
  model: "model"
});
export var CloudExtKeys = objFreeze({
  role: "role",
  roleInstance: "roleInstance",
  roleVer: "roleVer"
});
export var TraceExtKeys = objFreeze({
  traceId: "traceID",
  traceName: "name",
  parentId: "parentID"
});